import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Table,
  Input,
  UncontrolledTooltip,
  FormGroup,
  Label
} from "reactstrap";
import PaginationComponent from "../../components/Custom/Pagination";
// import ReactBSAlert from "react-bootstrap-sweetalert";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import { getUsersRequest, deleteUserRequest } from '../../api/user';
import { calcStartEndPage } from '../../helpers/pagination';
import { hasPermission } from "helpers/auth";

class Users extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
          users: null,
          alert: null,
          total: 0,
          pages: 0,
          current_page: 0,
          start_page: 0,
          end_page: 9,
          first_page: 0,
          last_page: 0,
          deleteUserId: '',
          filters: {limit: 25,},
          loading: true
        }
        this.timeout = null;
    }

    async componentDidMount() {
        await this.getUsers()
    }

    getUsers = async () => {   
        this.setState({loading: true})
        const { filters } = this.state;     
        const usersObj = await getUsersRequest(filters);
        const users = usersObj.users;
        const total = usersObj.total;
        const pages = Math.ceil(total / filters.limit);
        const last_page = pages - 1;
        const end_page = pages > 10 ? 9 : pages - 1;

        this.setState({
            users,
            total,
            pages,
            last_page,
            end_page,
            loading: false
        })
    }
  
    goTo = path => this.props.history.push(path);

    goToPage = async (page) => {
        const { pages, filters } = this.state;
        const usersObj = await getUsersRequest({...filters, page});
        const users = usersObj.users;
        const { start_page, end_page } = calcStartEndPage(page, pages);

        this.setState({
            users: users,
            current_page: page,
            start_page: start_page,
            end_page: end_page
        })
    }

    /*hideAlert = () => {
        this.setState({
          alert: null
        });
    };*/

    /*showConfirmDeleteAlert = (id) => {
        this.setState({
            alert: (
              <ReactBSAlert
                warning
                style={{ display: "block", marginTop: "-100px" }}
                title="Are you sure?"
                onConfirm={() => this.deleteUser(id)}
                onCancel={() => this.hideAlert()}
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                confirmBtnText="Yes, delete it!"
                cancelBtnText="Cancel"
                showCancel
                btnSize=""
              >
                The user will be deleted permanently
              </ReactBSAlert>
            )
        });
    }*/

    /*deleteUser = async (id) => {
        
    }*/

    onChangeSearch = (event) => {
        const { filters } = this.state;

		this.setState({
            filters: {
                ...filters,
                search: event.target.value,
			    page: 0
            }
		})
		if (this.timeout) {
			clearTimeout(this.timeout);
		}
		this.timeout = setTimeout(() => {
			this.getUsers();
		}, 300);
    }

    openConfirmation = (userId) => () => {
		this.setState({
			deleteUserId: userId
		});
		this.deleteConfirmationModal.toggle();
    }
    
    deleteUser = async () => {
		const { deleteUserId } = this.state;
        await deleteUserRequest(deleteUserId);
        this.getUsers()
	}

    render() {

        const {
            users,
            alert,
            pages,
            current_page,
            start_page,
            end_page,
            filters,
            loading
        } = this.state;

        return (
            <>
            <div className="content">
            {alert}
            <Row>
                <Col md="12">
                <Card>
                    <CardHeader>
                        <CardTitle className="d-inline-block" tag="h4">
                            Users
                        </CardTitle>
                        <FormGroup>
                            <Label>User</Label>
                            <Input placeholder="Search Users..." value={filters.search} type="text" onChange={this.onChangeSearch}></Input>
                        </FormGroup>
                        {hasPermission('CreateUser') ? <Button className="pull-right mb-3 add-btn" color="primary" onClick={() => this.goTo('/user/create')}><i className="tim-icons icon-simple-add" /> User</Button> : null}
                    </CardHeader>
                    <CardBody>
                    <Table responsive>
                        <thead className="text-primary">
                        <tr>
                            <th>Email</th>
                            <th>Name</th>
                            <th>Role</th>
                            <th className="text-right">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        {loading ?
                        <tr>
                            <td colSpan="12">Loading...</td>
                        </tr>
                        :   
                        users && users.length
                        ? users.map((user) => {
                            return (
                                <tr key={user._id}>
                                    <td>{user.email}</td>
                                    <td>{user.first_name} {user.last_name}</td>
                                    <td>{user.role}</td>
                                    <td className="text-right">
                                        <Button
                                            className="btn-link btn-icon"
                                            color="success"
                                            id={`tooltip-view-${user._id}`}
                                            size="sm"
                                            onClick={() => this.goTo(`/user?id=${user._id}`)}
                                        >
                                            <i className="tim-icons icon-zoom-split" />
                                        </Button>
                                        <UncontrolledTooltip
                                            delay={0}
                                            target={`tooltip-view-${user._id}`}
                                        >
                                            Ver
                                        </UncontrolledTooltip>
                                        {hasPermission('EditUser') ? <>
                                            <Button
                                                className="btn-link btn-icon"
                                                color="info"
                                                id={`tooltip-edit-${user._id}`}
                                                size="sm"
                                                onClick={() => this.goTo(`/user/edit?id=${user._id}`)}
                                            >
                                                <i className="tim-icons icon-pencil" />
                                            </Button>
                                            <UncontrolledTooltip
                                                delay={0}
                                                target={`tooltip-edit-${user._id}`}
                                            >
                                                Editar
                                            </UncontrolledTooltip>
                                            <Button
                                                className="btn-link btn-icon"
                                                color="danger"
                                                id={`tooltip-delete-${user._id}`}
                                                size="sm"
                                                onClick={this.openConfirmation(user._id)}
                                            >
                                                <i className="tim-icons icon-simple-remove" />
                                            </Button>
                                            <UncontrolledTooltip
                                                delay={0}
                                                target={`tooltip-delete-${user._id}`}
                                            >
                                                Deletar
                                            </UncontrolledTooltip>
                                        </> : null}
                                    </td>
                                </tr>
                            )
                        })
                        :   <tr>
                                <td colSpan="4">There's no user to show</td>
                            </tr>
                        }
                        </tbody>
                    </Table>
                    {users?.length > 0 && 
                        <PaginationComponent 
                            pages={pages}
                            current_page={current_page}
                            start_page={start_page}
                            end_page={end_page}
                            goToPage={this.goToPage}
                        />
                    }
                    </CardBody>
                </Card>
                </Col>
            </Row>
            <ConfirmationModal
                ref={el => this.deleteConfirmationModal = el}
                title="Delete User?"
                buttons={[
                    { title: 'Cancel', className: 'btn-primary-override btn btn-primary' },
                    { title: 'Delete', className: 'btn-danger-override btn btn-danger', onClick: this.deleteUser }
                ]}
            >
                Are you sure you want to delete this user?
            </ConfirmationModal>
            </div>
        </>
        );
    }
}

export default Users;
